
import { i18nText } from '@/locales';
import { IPaymentArticlesType } from "@/entity/finance/payment_articles/paymentArticlesType.types";

export const PaymentTypes: IPaymentArticlesType[] | null = [
    { id: 2, name: i18nText("Доходы") },
    { id: 1, name: i18nText("Расходы") },
];
export class PaymentArticlesFormData {
    id?: number | null | undefined;
    name: string;
    type: IPaymentArticlesType | null;
    type_id: number | null;
    comment: string | null;
    salon_id: number;
    constructor(salon_id: number) {
        this.name = "";
        this.type = null;
        this.type = { id: null, name: "" };
        this.type_id= null;
        this.comment = "";
        this.salon_id = salon_id;
    }
}
export const articlesRules = {
    name: [{ required: true, message: i18nText("Пожалуйста укажите наименование"), trigger: "change" }],
    type_id: [{ required: true, message: i18nText("Пожалуйста укажите тип"), trigger: "change" }],
    /*type: [
        {
            type: "object",
            required: true,
            fields: {
                id: { type: "number", required: true },
            },
            message: "Пожалуйста укажите тип",
            trigger: "change",
        },
    ],*/
};
